import { Shield, Lock, CheckCircle, Award } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const badges = [
  {
    icon: CheckCircle,
    title: "Microsoft Compatible",
    description: "Works with Outlook",
    color: "text-brand-blue",
  },
  {
    icon: Shield,
    title: "GDPR Compliant",
    description: "Data protection first",
    color: "text-secondary",
  },
  {
    icon: Lock,
    title: "End-to-End Encrypted",
    description: "Your data stays private",
    color: "text-brand-cyan",
  },
  {
    icon: Award,
    title: "Privacy-First",
    description: "Zero data retention",
    color: "text-brand-orange",
  },
];

export const TrustBadges = () => {
  const { ref: headerRef, animationClass: headerAnimation } = useScrollAnimation<HTMLDivElement>({
    type: 'slide-up',
    threshold: 0.3,
  });

  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="container px-4">
        <div 
          ref={headerRef}
          className={`text-center mb-8 md:mb-12 ${headerAnimation}`}
        >
          <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-2">
            Trusted by professionals
          </p>
          <h2 className="text-2xl md:text-3xl font-bold">
            Security & Compliance Built-In
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
          {badges.map((badge, index) => {
            const { ref, animationClass } = useScrollAnimation<HTMLDivElement>({
              type: 'scale',
              delay: index * 100,
              threshold: 0.2,
            });

            return (
              <div
                key={index}
                ref={ref}
                className={`flex flex-col items-center text-center p-4 md:p-6 rounded-xl bg-card border border-border shadow-card hover:shadow-elevated transition-all duration-300 group ${animationClass}`}
              >
                <div className={`p-3 rounded-full bg-muted mb-3 group-hover:scale-110 transition-transform ${badge.color}`}>
                  <badge.icon className="w-5 h-5 md:w-6 md:h-6" />
                </div>
                <h3 className="font-semibold text-sm md:text-base mb-1">
                  {badge.title}
                </h3>
                <p className="text-xs md:text-sm text-muted-foreground">
                  {badge.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
